
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api';

const baseUrl = '20260323KLGXYLJH';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {

  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '上游新闻X可灵AI高校原力计划',
      url: location.href,
      subtitle: `@各位高校同学 快来加入AI视频创作，在上游报名可抽可灵AI礼品卡`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '上游新闻X可灵AI高校原力计划',
        subtitle: `@各位高校同学 快来加入AI视频创作，在上游报名可抽可灵AI礼品卡`,
        image: cover,
      });
    }
  }

  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
